// extracted by mini-css-extract-plugin
module.exports = {"logo-container":"logo_logo-container__25o-Y","logo":"logo_logo__3UN4X"};